import * as React from 'react';
import styled from "styled-components";
import { MapLegendProps, MapLegendStyleProp } from '../../interface/MapInterface';
import { numberWithDollarSign, numberWithCommas, legendFormat } from "./Helpers";

const LegendContainer = styled.span`
    pointer-events: none;
    position: ${props => props.isEmployee ? "" : props.factSheet || props.isZoomed ? "static" : "absolute"};
    display: ${props => props.factSheet || props.isZoomed ? "block" : "inline"};
    top: ${ (props: MapLegendStyleProp) => props.factSheet || props.isZoomed ? "auto"
        : props.isEmployee ? 0
        : props.mapHeight - props.legendHight - 5}px;
	left: ${ (props: MapLegendStyleProp) => props.factSheet || props.isZoomed ? "auto"
        : props.isEmployee ? 0
        : props.mapWidth + 20}px`;


class MapLegend extends React.Component<MapLegendProps> {

    getLegendData = () => {

        if (this.props.isEmployee) {
            // Prefer array form so duplicate colors can't collapse rows
            return this.props.colorScale.employeeLegend();
        } else {
            //.reverse() will mutate the array in place, need to copy the array first
            const legendData = [...this.props.colorScheme].reverse().map((color, i) => {
                const range = this.props.colorScale.invertExtent(color);

                //const start_old = range.length > 0 && range[0] ? numberWithDollarSign(range[0].toFixed(0)) : 0;
                const start = range.length > 0 && range[0] ? legendFormat(range[0], i, "start") : 0;
                
                //let end_old = (i < this.props.colorScheme.length - 1)
                  //  ? numberWithDollarSign((range[1] - 1).toFixed(0))
                  //  : range.length > 1 && range[1] && numberWithDollarSign(range[1].toFixed(0));

                let end = (i < this.props.colorScheme.length - 1)
                    ? legendFormat((range[1] - 1), i, "end")
                    : range.length > 1 && range[1] && legendFormat(range[1], i, "end");

                const rangeText = (end !== '$NaN') ? `${start} to ${end}` : `${start}+`;
                return { [color]: rangeText };
            }).reduce((obj, item) => {
                const colorKey = Object.keys(item)[0];
                obj[colorKey] = item[colorKey];
                return obj;
            },
                {});

            if (this.props.isCongress && this.props.isInstate) {
                legendData["#d3d3d3"] = "No Spending found";
            }

            return legendData;
        }
    }
    render() {
        const legendData = this.getLegendData();
        const employeeLegendRows = this.props.isEmployee
            ? legendData.map((item, i) => ({ key: `${item.color}-${i}`, fill: item.color, label: item.label }))
            : Object.keys(legendData).map(color => ({
                key: color,
                fill: color,
                label: legendData[color]
            }));
        const factSheetItemCount = this.props.isEmployee ? legendData.length : Object.keys(legendData).length;
        const factSheetRowHeight = 18;
        const factSheetTitleHeight = 20;
        const factSheetLegendHeight = factSheetTitleHeight + factSheetItemCount * factSheetRowHeight + 6;
        const legendHeight = this.props.factSheet
            ? factSheetLegendHeight
            : this.props.legendBoxHeight + this.props.legendTitleHeight + 2 * this.props.legendPadding;
        //console.log(this.props)
        const spendingType = this.props.tablename.charAt(0).toUpperCase() + this.props.tablename.slice(1);
        const fontSize1 = (this.props.isZoomed) ? '17px' : (this.props.factSheet) ? '14px' : '14px';
        const fontSize2 = (this.props.isZoomed) ? '16px' : '11px';
        return (
            <LegendContainer
                factSheet={this.props.factSheet}
                className={this.props.factSheet ? 'factsheet_legend' : this.props.isZoomed ? 'map-legend--zoomed' : ''}
                isCongress={this.props.isCongress}
                isZoomed={this.props.isZoomed}
                isInState={this.props.isInstate}
                isEmployee={this.props.isEmployee}
                mapWidth={this.props.mapAreaWidth}
                mapHeight={this.props.mapAreaHeight}
                legendHight={legendHeight}>
                <svg
                    width={this.props.isEmployee ? 220 : this.props.factSheet ? 215 : this.props.legendAreaWidth}
                    height={this.props.isEmployee ? 250 : this.props.isZoomed ? 180 : this.props.factSheet ? factSheetLegendHeight : this.props.legendBoxHeight + 20 + this.props.legendTitleHeight + 2 * this.props.legendPadding}
                >
                    <g>
                        {/*<text style={{ fontSize: '18px', "height": "10px" }}>well</text>*/}
                        <text style={{ fontSize: fontSize1, fontWeight: 'bold' }}
                            transform={`translate(${this.props.factSheet ? "0" : "2"},${this.props.isZoomed ? "20" : this.props.factSheet ? "14" : "15"})`}>
                            {this.props.factSheet ? 'Spending Amount' : (this.props.isEmployee) ? 'Employee Count' : `${spendingType === "All" ? "" : spendingType} Expenditures`}
                        </text>
                        <rect style={{ fill: 'none' }} width={this.props.legendBoxWidth} height={(this.props.colorScheme.length + 1) * this.props.legendLineHeight - this.props.legendCellHeight + 2 * this.props.legendBoxPadding} transform={`translate(0,${this.props.legendTitleHeight})`} />
                        {this.props.isEmployee &&

                            <g transform={`translate(5,${this.props.legendLineHeight + this.props.legendBoxPadding})`}>
                                {
                                    employeeLegendRows.map((row, i) => (
                                        <React.Fragment key={row.key}>
                                            <rect
                                                style={{ fill: row.fill, stroke: '#d4d4d4' }}
                                                width={this.props.legendCellWidth}
                                                height={this.props.legendCellHeight}
                                                y={(i + 1) * this.props.legendLineHeight - this.props.legendCellHeight}
                                            />
                                            <text
                                                style={{ fontSize: '12px' }}
                                                x={25}
                                                y={((i + 1) * this.props.legendLineHeight) - 5}
                                            >
                                                {row.label}
                                            </text>
                                        </React.Fragment>
                                    ))
                                }
                            </g>
                        }
                        {this.props.factSheet &&
                            <g transform={`translate(0,${factSheetTitleHeight})`}>
                                {
                                    Object.keys(legendData).map((color, i) => (
                                        <g key={color} transform={`translate(0, ${i * factSheetRowHeight})`}>
                                            <rect style={{ fill: color, stroke: '#bbb', strokeWidth: 0.5 }} width={14} height={14} />
                                            <text style={{ fontSize: '13px' }} x={22} y={11}>{legendData[color]}</text>
                                        </g>
                                    ))
                                }
                            </g>
                        }
                        {!this.props.isEmployee && !this.props.factSheet &&
                            <g transform={`translate(5,${this.props.legendLineHeight + this.props.legendBoxPadding})`}>
                                {
                                    Object.keys(legendData).map((color, i) => {
                                        return <rect key={color} style={{ fill: color }} width={this.props.legendCellWidth} height={
                                            this.props.legendCellHeight} y={(i + 1) * this.props.legendLineHeight - this.props.legendCellHeight} />
                                    })

                                }
                                {
                                Object.keys(legendData).map((color, i) => {
                                    return <text style={{ fontSize: fontSize2 }} key={color} x={25} y={(i + 1) * this.props.legendLineHeight}>{legendData[color]}</text>
                                    })

                                }
                            </g>
                        }
                    </g>          
                </svg>
            </LegendContainer>)
    }
}

export default MapLegend;